import videojs from 'video.js';

class TvVideoControl {
  constructor(themePath) {
    this.themePath = themePath;

    this.$slides = document.querySelectorAll('.js-tv-slide');
    this.$video = document.querySelector('.js-video');
    this.$cover = document.querySelector('.js-video-cover');
    this.eventType = this._getEventType();
    this._init();
    this._addEvent();
  }

  _getEventType() {
    const isTouchCapable =
      'ontouchstart' in window ||
      (window.DocumentTouch && document instanceof DocumentTouch);

    return isTouchCapable ? 'touchstart' : 'click';
  }

  _toggle() {
    this.$video.classList.toggle('is-open');
  }

  _playerInit() {
    this.player = videojs('js-tv-video', {
      fluid: true,
      aspectRatio: '16:9',
      autoplay: false,
      preload: 'auto',
      fill: true,
      responsive: true,
      loadingSpinner: true,
      languages: {
        ja: {
          Play: '再生',
          Pause: '停止',
          'Play Video': '再生',
          Mute: '消音',
          'Playback Rate': '再生速度',
          'Picture-in-Picture': 'ピクチャインピクチャ',
          Fullscreen: '全画面表示',
          'Non-Fullscreen': '通常表示',
        },
      },
      language: 'ja',
    });
  }

  _movieSet(num) {
    this.player.pause();
    const videoSrc = this.themePath + '/assets/video/tv/tv_' + num + '.mp4';
    this.player.src({ type: 'video/mp4', src: videoSrc });
  }

  _addEvent() {
    this.$slides.forEach((slide) => {
      const slide_num = slide.getAttribute('data-num');
      slide.addEventListener(this.eventType, () => {
        this._toggle();
        this._movieSet(slide_num);

        setTimeout(() => {
          this.player.play();
        }, 500);
      });
    });

    this.$cover.addEventListener(this.eventType, () => {
      this.player.pause();
      this.player.currentTime(0);
      this._toggle();
    });
  }

  _init() {
    this._playerInit();
  }
}

export { TvVideoControl };
